<div class="content-card">
    <div class="card-inner">
        <p-fluid>
            <div class="font-semibold text-xl module-name mb-4">
                Execute Tests
            </div>

            <!-- View Mode Toggle -->
            <div class="flex items-center gap-3 mb-4">
                <div class="view-mode-toggle">
                    <button class="vmt-btn" [class.active]="viewModel.viewMode() === 'list'" (click)="viewModel.setViewMode('list')">
                        <i class="pi pi-list"></i> Scenario List
                    </button>
                    <button class="vmt-btn" [class.active]="viewModel.viewMode() === 'group'" (click)="viewModel.setViewMode('group')">
                        <i class="pi pi-th-large"></i> Group Execute
                    </button>
                </div>
            </div>

            <!-- List View -->
            <ng-container *ngIf="viewModel.viewMode() === 'list'">
                <!-- Filter Bar (inline) -->
                <div class="filter-bar">
                    <div class="filters">
                        <div class="filter-group">
                            <label>Client:</label>
                            <p-select [options]="viewModel.clientFilterOptions()"
                                [ngModel]="viewModel.selectedClientFilter()" [filter]="true"
                                placeholder="All Clients"
                                [disabled]="viewModel.isClientDropdownDisabled()"
                                [showClear]="!!viewModel.selectedClientFilter() && viewModel.selectedClientFilter() !== 'default'"
                                (onChange)="viewModel.filterByClient($event.value)"
                                (onClear)="viewModel.resetClientToDefault()"
                                [appendTo]="'body'"
                                [style]="{'width': '180px'}">
                            </p-select>
                        </div>
                        <div class="filter-group">
                            <label>Package:</label>
                            <p-select [options]="viewModel.packageFilterOptions()"
                                [ngModel]="viewModel.selectedPackageFilter()" [filter]="true"
                                placeholder="Filter by Package"
                                [showClear]="!!viewModel.selectedPackageFilter()"
                                (onChange)="viewModel.filterByPackageName($event.value)"
                                (onClear)="viewModel.clearPackageFilter()"
                                [appendTo]="'body'"
                                [style]="{'width': '180px'}">
                            </p-select>
                        </div>
                        <div class="filter-group">
                            <label>Test Type:</label>
                            <p-multiSelect [options]="viewModel.testTypeFilterOptions()"
                                [ngModel]="viewModel.selectedTestTypeFilter()"
                                [filter]="true"
                                placeholder="Filter by Test Type"
                                [showClear]="viewModel.selectedTestTypeFilter().length > 0"
                                (onChange)="viewModel.filterByTestType($event.value)"
                                (onClear)="viewModel.clearTestTypeFilter()"
                                optionLabel="label"
                                optionValue="value"
                                [appendTo]="'body'"
                                [style]="{'width': '220px'}"
                                [maxSelectedLabels]="2"
                                selectedItemsLabel="{0} selected">
                            </p-multiSelect>
                        </div>
                        <div class="filter-group">
                            <label>Functional Area:</label>
                            <p-select [options]="viewModel.functionalAreaFilterOptions()"
                                [ngModel]="viewModel.selectedFunctionalAreaFilter()" [filter]="true"
                                placeholder="Filter by Functional Area"
                                [showClear]="!!viewModel.selectedFunctionalAreaFilter()"
                                (onChange)="viewModel.filterByFunctionalArea($event.value)"
                                (onClear)="viewModel.clearFunctionalAreaFilter()"
                                optionLabel="label" optionValue="value"
                                [appendTo]="'body'"
                                [style]="{'width': '200px'}">
                            </p-select>
                        </div>
                    </div>
                    <div class="filter-actions">
                        <!-- Cloud Execution Toggle (always visible) -->
                        <div class="cloud-toggle-pill" [class.active]="viewModel.executeOnCloud()">
                            <button class="cloud-toggle-btn" (click)="viewModel.setExecuteOnCloud(!viewModel.executeOnCloud())">
                                <i class="pi" [ngClass]="viewModel.executeOnCloud() ? 'pi-cloud' : 'pi-desktop'"></i>
                                {{ viewModel.executeOnCloud() ? 'Cloud' : 'Local' }}
                            </button>
                        </div>
                        <div class="search-container">
                            <p-iconfield iconPosition="left">
                                <p-inputicon>
                                    <i class="pi pi-search"></i>
                                </p-inputicon>
                                <input pInputText type="text" #searchInput
                                    [value]="viewModel.scenarioSearchText()"
                                    (input)="viewModel.onScenarioSearchInput(searchInput.value)"
                                    (keyup.enter)="viewModel.onScenarioSearch(searchInput.value)"
                                    placeholder="Search scenarios..." />
                            </p-iconfield>
                        </div>
                    </div>
                </div>

                <!-- Package Expiration Warning Banner -->
                <div *ngIf="viewModel.isPackageExpired()"
                     class="flex items-center gap-3 p-3 mb-3 bg-red-50 border border-red-300 rounded-lg">
                    <i class="pi pi-exclamation-triangle text-red-600"></i>
                    <p class="text-red-700 text-sm m-0">{{ viewModel.getExpirationMessage() }}</p>
                </div>

                <!-- Incomplete Auth Profile Warning Banner -->
                <div *ngIf="viewModel.hasAnyIncompleteAuthScenarios()"
                     class="flex items-center gap-3 p-3 mb-3 bg-orange-50 border border-orange-300 rounded-lg">
                    <i class="pi pi-exclamation-triangle text-orange-600"></i>
                    <p class="text-orange-700 text-sm m-0">Some scenarios have incomplete authentication profiles. Update credentials in Auth Profiles before executing.</p>
                </div>

            <!-- Simple Job Status line -->
            <div *ngIf="viewModel.currentJob()" class="mb-3 p-2 border rounded-lg flex items-center gap-2">
                <i class="pi pi-cloud text-blue-500"></i>
                <span class="font-medium text-sm">Job:</span>
                <p-tag
                    [severity]="viewModel.getJobTagSeverity(viewModel.currentJob()?.status)"
                    [value]="viewModel.currentJob()?.status">
                </p-tag>
                <span class="text-xs text-gray-500">{{ viewModel.currentJob()?.jobId }}</span>
                <span class="text-xs text-gray-500" *ngIf="viewModel.currentJob()?.scenarioCount">· {{ viewModel.currentJob()?.scenarioCount }} scenarios</span>
            </div>

              <!-- Multi-Scenario Execution Progress Section (hidden when Cloud selected) -->
              <div *ngIf="!viewModel.executeOnCloud() && (viewModel.isMultiExecuting() || (viewModel.currentMultiExecutionIndex() >= 0 && viewModel.multiExecutionQueue().length > 0))" 
                 class="mb-4 p-4 border-1 surface-border border-round" style="background-color: #f8f9fa;">
                
                <div *ngIf="viewModel.multiExecutionQueue()[viewModel.currentMultiExecutionIndex()] as currentScenario">
                    <div class="flex align-items-center mb-3">
                        <h5 class="m-0">Execution Progress</h5>
                        <div class="ml-auto" *ngIf="viewModel.isMultiExecuting()">
                            <p-button label="Stop Execution"
                                      icon="pi pi-stop-circle"
                                      severity="danger"
                                      (click)="viewModel.stopCurrentMultiExecution()" />
                        </div>
                        <div class="ml-auto" *ngIf="!viewModel.isMultiExecuting() && viewModel.executionStatus()[currentScenario.id] && (viewModel.executionStatus()[currentScenario.id].passed !== undefined || viewModel.executionStatus()[currentScenario.id].failed !== undefined)">
                            <p-button label="View Result" 
                                      icon="pi pi-chart-bar" 
                                      severity="success"
                                      (click)="viewModel.viewMultiExecutionResults()" />
                        </div>
                    </div>
                    
                    <!-- Total steps progress bar -->
                    <div class="mb-4">
                        <div class="flex justify-content-between mb-2">
                            <span class="font-semibold">Test Scenario execution: {{ viewModel.currentMultiExecutionIndex() + 1 }}/{{ viewModel.multiExecutionQueue().length }}</span>
                        </div>
                        <p-progressBar 
                            [value]="viewModel.getTotalStepsProgress()" 
                            [showValue]="false">
                        </p-progressBar>
                    </div>

                    <!-- Current scenario execution details or completion info -->
                    <ng-container *ngIf="viewModel.getCurrentScenarioProgress() as progress">
                        <div class="flex align-items-center gap-2">
                            <span>
                                {{ progress.running ? 'Currently executing' : 'Last executed' }}: Scenario <strong>{{ currentScenario.scenarioId }}</strong>
                            </span>
                            <span> - <strong>Step {{ progress.current }} of {{ progress.total }}</strong></span>
                            <span *ngIf="currentScenario.scenarioName" class="text-color-secondary">({{ currentScenario.scenarioName }})</span>
                            <p-tag *ngIf="progress.running" value="In Progress" severity="info" [rounded]="true" class="ml-2"></p-tag>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!viewModel.getCurrentScenarioProgress()">
                        <div *ngIf="viewModel.isMultiExecuting(); else finishedOrIdle" class="flex align-items-center gap-2">
                            <span>Preparing to execute...</span>
                            <p-tag value="Starting" severity="info" [rounded]="true" class="ml-2"></p-tag>
                        </div>
                        <ng-template #finishedOrIdle>
                            <div *ngIf="viewModel.isMultiExecutionCompleted()" class="flex align-items-center gap-2">
                                <span>Test Scenario execution completed</span>
                                <p-tag value="Completed" severity="success" [rounded]="true" class="ml-2"></p-tag>
                            </div>
                            <div *ngIf="viewModel.isMultiExecutionCompleted()" class="mt-2 text-sm text-color-secondary">
                                <ng-container *ngIf="viewModel.getMultiExecutionSummary() as summary">
                                    <span>Summary: </span>
                                    <span class="font-medium text-green-600">Passed {{ summary.passedScenarios }}</span>
                                    <span> / </span>
                                    <span class="font-medium text-red-600">Failed {{ summary.failedScenarios }}</span>
                                    <span> of {{ summary.totalScenarios }} scenario(s)</span>
                                </ng-container>
                            </div>
                            <!-- Show stopped state when execution ended early -->
                            <div *ngIf="!viewModel.isMultiExecutionCompleted() && !viewModel.isMultiExecuting()" class="flex align-items-center gap-2 mt-2">
                                <span>Test Scenario execution stopped</span>
                                <p-tag value="Stopped" severity="warning" [rounded]="true" class="ml-2"></p-tag>
                            </div>
                            <div *ngIf="!viewModel.isMultiExecutionCompleted() && !viewModel.isMultiExecuting()" class="mt-1 text-sm text-color-secondary">
                                <ng-container *ngIf="viewModel.getMultiExecutionSummary() as summary">
                                    <span>Summary: </span>
                                    <span class="font-medium text-green-600">Passed {{ summary.passedScenarios }}</span>
                                    <span> / </span>
                                    <span class="font-medium text-red-600">Failed {{ summary.failedScenarios }}</span>
                                    <span> of {{ summary.totalScenarios }} scenario(s)</span>
                                </ng-container>
                                <ng-container *ngIf="viewModel.getStoppedScenarioProgress() as stopped">
                                    <span class="ml-3">Stopped at Step <strong>{{ stopped.current }}</strong> of <strong>{{ stopped.total }}</strong></span>
                                </ng-container>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>
            </div>

            <!-- Scenario Table -->
            <p-table #dt [value]="viewModel.scenarios() || []" [rows]="10" [paginator]="true"
                [first]="viewModel.scenarioFirst()"
                [totalRecords]="viewModel.scenarioTotal()" [lazy]="true" (onLazyLoad)="viewModel.onScenarioPageChange($event)"
                [globalFilterFields]="['scenarioId','scenarioName','scenarioDescription','package.packageName','functionalArea.name','functionalArea.referenceValue','testType.referenceValue']"
                [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} scenarios"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]"
                styleClass="scenario-table">

                <ng-template #header>
                    <tr>
                        <th style="width: 44px; text-align: center">
                            <p-checkbox [binary]="true"
                                [ngModel]="viewModel.allSelected()"
                                (ngModelChange)="viewModel.toggleSelectAll($event)">
                            </p-checkbox>
                        </th>
                        <th pSortableColumn="package.packageName">
                            Package
                            <p-sortIcon field="package.packageName" />
                        </th>
                        <th pSortableColumn="functionalArea.name">
                            Functional Area
                            <p-sortIcon field="functionalArea.name" />
                        </th>
                        <th pSortableColumn="testType.referenceValue">
                            Test Type
                            <p-sortIcon field="testType.referenceValue" />
                        </th>
                        <th pSortableColumn="scenarioId" style="width: 120px">
                            Scenario ID
                            <p-sortIcon field="scenarioId" />
                        </th>
                        <th pSortableColumn="scenarioName">
                            Scenario Name
                            <p-sortIcon field="scenarioName" />
                        </th>
                        <th pSortableColumn="scenarioDescription">
                            Description
                            <p-sortIcon field="scenarioDescription" />
                        </th>
                        <th style="width: 90px">Steps</th>
                        <th style="width: 100px">Status</th>
                        <th style="width: 70px; text-align: center">Action</th>
                    </tr>
                </ng-template>

                <ng-template #body let-scenario>
                    <tr [class.selected-row]="scenario.selected"
                        [class.disabled-row]="viewModel.isScenarioPackageExpired(scenario) || viewModel.isScenarioAuthIncomplete(scenario)">
                        <td style="text-align: center">
                            <p-checkbox [(ngModel)]="scenario.selected" [binary]="true"
                                (onChange)="viewModel.onScenarioSelectionChange()"
                                [disabled]="!scenario.stepCount || scenario.stepCount === 0 || viewModel.isScenarioPackageExpired(scenario) || viewModel.isScenarioAuthIncomplete(scenario)">
                            </p-checkbox>
                        </td>
                        <td>{{ scenario.functionalArea?.clientPackageMapping?.package?.packageName || scenario.functionalArea?.package?.packageName || '-' }}</td>
                        <td>{{ scenario.functionalArea?.name || scenario.functionalArea?.referenceValue || '-' }}</td>
                        <td>{{ scenario.testType?.referenceValue || '-' }}</td>
                        <td>{{ scenario.scenarioId || '-' }}</td>
                        <td>
                            {{ scenario.scenarioName || '-' }}
                            <span *ngIf="viewModel.isScenarioAuthIncomplete(scenario)"
                                class="ml-2 text-orange-500 text-xs font-medium"
                                pTooltip="Authentication profile credentials are incomplete." tooltipPosition="top">
                                <i class="pi pi-exclamation-triangle"></i>
                            </span>
                        </td>
                        <td>{{ scenario.scenarioDescription || '-' }}</td>
                        <td>
                            <span class="steps-pill">{{ scenario.stepCount || 0 }}</span>
                        </td>
                        <td>
                            <ng-container *ngIf="viewModel.executionStatus()[scenario.id] as st; else statusReady">
                                <span class="status-badge" *ngIf="st.running">
                                    <i class="pi pi-spinner pi-spin" style="font-size:10px;color:#3b82f6;"></i>
                                    <span>Running {{ st.current }}/{{ st.total }}</span>
                                </span>
                                <span class="status-badge" *ngIf="!st.running && (st.failed || 0) > 0">
                                    <span class="status-dot failed"></span> Failed
                                </span>
                                <span class="status-badge" *ngIf="!st.running && (st.failed || 0) === 0 && st.passed !== undefined">
                                    <span class="status-dot ready"></span> Passed
                                </span>
                                <span class="status-badge" *ngIf="!st.running && (st.failed || 0) === 0 && st.passed === undefined && (st.current > 0 || st.total > 0)" style="color: #d97706;">
                                    <span class="status-dot draft"></span> Stopped {{ st.current }}/{{ st.total }}
                                </span>
                            </ng-container>
                            <ng-template #statusReady>
                                <span class="status-badge" *ngIf="!scenario.stepCount || scenario.stepCount === 0" style="color: #9ca3af;">
                                    <span class="status-dot draft"></span> Not Ready
                                </span>
                                <span class="status-badge" *ngIf="scenario.stepCount > 0 && viewModel.isScenarioPackageExpired(scenario)" style="color: #d97706;">
                                    <span class="status-dot draft"></span> Expired
                                </span>
                                <span class="status-badge" *ngIf="scenario.stepCount > 0 && !viewModel.isScenarioPackageExpired(scenario)" style="color: #059669;">
                                    <span class="status-dot ready"></span> Ready
                                </span>
                            </ng-template>
                        </td>
                        <td style="text-align: center">
                            <button class="btn-eye"
                                *ngIf="!viewModel.isRunning(scenario)"
                                [disabled]="viewModel.isMultiExecuting() || !scenario.stepCount || scenario.stepCount === 0 || viewModel.isScenarioPackageExpired(scenario) || (viewModel.showTenantSelector() && !scenario.selected)"
                                (click)="viewModel.runScenario(scenario)"
                                pTooltip="Execute" tooltipPosition="top">
                                <i class="pi pi-play"></i>
                            </button>
                            <button class="btn-eye btn-stop-action"
                                *ngIf="viewModel.isRunning(scenario) && !viewModel.isMultiExecuting()"
                                (click)="viewModel.stopScenario(scenario)"
                                pTooltip="Stop" tooltipPosition="top">
                                <i class="pi pi-stop"></i>
                            </button>
                        </td>
                    </tr>
                </ng-template>

                <ng-template #emptymessage>
                    <tr>
                        <td colspan="10" class="noData">No scenarios found.</td>
                    </tr>
                </ng-template>
            </p-table>

            <!-- Execution Config Bar (dark, appears when scenarios selected) -->
            <div class="exec-config-bar" *ngIf="viewModel.getSelectedCount() > 0">
                <div class="ecb-item">
                    <span class="ecb-label">Selected:</span>
                    <span class="ecb-value">{{ viewModel.getSelectedCount() }} scenarios</span>
                </div>
                <div class="ecb-actions" style="display: flex; align-items: center; gap: 12px;">
                    <!-- Tenant Selection as checkboxes -->
                    <ng-container *ngIf="viewModel.showTenantSelector()">
                        <span class="ecb-label">Tenant <span style="color: #ef4444;">*</span>:</span>
                        <div style="display: flex; align-items: center; gap: 10px;">
                            <div *ngFor="let tenant of viewModel.tenantOptions()" style="display: flex; align-items: center; gap: 4px;">
                                <p-radioButton [name]="'tenant'" [value]="tenant.id"
                                    [ngModel]="viewModel.selectedTenantId()"
                                    (onClick)="viewModel.selectTenant(tenant.id)">
                                </p-radioButton>
                                <label style="color: white; font-size: 12px; cursor: pointer;" (click)="viewModel.selectTenant(tenant.id)">{{ tenant.displayLabel }}</label>
                            </div>
                        </div>
                    </ng-container>
                    <button class="btn-execute-group"
                        [disabled]="viewModel.isMultiExecuting() || (viewModel.showTenantSelector() && !viewModel.selectedTenantId())"
                        (click)="viewModel.executeMultipleScenariosDirectly()">
                        <i class="pi pi-play-circle"></i> Execute Selected ({{ viewModel.getSelectedCount() }})
                    </button>
                </div>
            </div>
            </ng-container>

            <!-- Group Execute View -->
            <ng-container *ngIf="viewModel.viewMode() === 'group'">
                <!-- Client Filter + Cloud Toggle (group view) -->
                <div class="filter-bar">
                    <div class="filters">
                        <div class="filter-group">
                            <label>Client:</label>
                            <p-select [options]="viewModel.clientFilterOptions()"
                                [ngModel]="viewModel.selectedClientFilter()" [filter]="true"
                                placeholder="All Clients"
                                [disabled]="viewModel.isClientDropdownDisabled()"
                                [showClear]="!!viewModel.selectedClientFilter() && viewModel.selectedClientFilter() !== 'default'"
                                (onChange)="viewModel.filterByClient($event.value)"
                                (onClear)="viewModel.resetClientToDefault()"
                                [appendTo]="'body'"
                                [style]="{'width': '220px'}">
                            </p-select>
                        </div>
                    </div>
                    <div class="filter-actions">
                        <div class="cloud-toggle-pill" [class.active]="viewModel.executeOnCloud()">
                            <button class="cloud-toggle-btn" (click)="viewModel.setExecuteOnCloud(!viewModel.executeOnCloud())">
                                <i class="pi" [ngClass]="viewModel.executeOnCloud() ? 'pi-cloud' : 'pi-desktop'"></i>
                                {{ viewModel.executeOnCloud() ? 'Cloud' : 'Local' }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Loading indicator for all scenarios -->
                <div *ngIf="viewModel.allClientScenariosLoading()" class="flex items-center gap-2 py-3 px-4" style="color: #64748b; font-size: 13px;">
                    <i class="pi pi-spin pi-spinner"></i> Loading all scenarios for grouping...
                </div>

                <!-- Group Controls Bar -->
                <div class="group-controls-bar">
                    <label class="gc-label">Group By:</label>
                    <p-select [options]="[{label: 'Functional Area', value: 'functionalArea'}, {label: 'Test Type', value: 'testType'}]"
                        [ngModel]="viewModel.groupByField()"
                        (onChange)="viewModel.setGroupByField($event.value)"
                        optionLabel="label" optionValue="value"
                        [style]="{'width': '200px'}">
                    </p-select>
                    <div class="gc-actions">
                        <button class="btn-outline-gc" (click)="viewModel.selectAllGroups()">
                            <i class="pi pi-check-square"></i> Select All
                        </button>
                        <button class="btn-outline-gc" (click)="viewModel.deselectAllGroups()">
                            <i class="pi pi-times"></i> Unselect All
                        </button>
                    </div>
                </div>

                <!-- No Data Message -->
                <div *ngIf="!viewModel.allClientScenariosLoading() && viewModel.enabledGroups().length === 0 && viewModel.disabledGroups().length === 0"
                     class="flex items-center justify-center py-6 text-gray-500 text-sm">
                    No Scenario available
                </div>

                <!-- Selected Groups -->
                <div *ngIf="viewModel.enabledGroups().length > 0" class="section-label-bar">
                    Selected Groups ({{ viewModel.enabledGroups().length }})
                </div>
                <div class="group-list">
                    <div *ngFor="let group of viewModel.enabledGroups()">
                        <div class="group-item">
                            <div class="gi-icon" [style.background]="viewModel.getGroupIconBg(group.name)" [style.color]="viewModel.getGroupIconColor(group.name)">
                                <i class="pi" [ngClass]="viewModel.getGroupIcon(group.name)"></i>
                            </div>
                            <div class="gi-body">
                                <div class="gi-name">{{ group.name }}</div>
                                <div class="gi-meta">
                                    {{ viewModel.getGroupSelectedCount(group.name) }}/{{ group.scenarioCount }} scenarios selected
                                </div>
                            </div>
                            <div class="gi-right">
                                <button class="btn-outline-gc" (click)="viewModel.toggleGroupExpand(group.name)" style="font-size: 11px;">
                                    <i class="pi" [ngClass]="viewModel.isGroupExpanded(group.name) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                                    {{ viewModel.isGroupExpanded(group.name) ? 'Collapse' : 'Expand' }}
                                </button>
                                <button class="toggle-btn on" (click)="viewModel.toggleGroup(group.name)"></button>
                            </div>
                        </div>
                        <!-- Expandable scenario list for unselecting individual scenarios -->
                        <div *ngIf="viewModel.isGroupExpanded(group.name)" style="padding: 8px 20px 12px 64px; background: #f9fafb; border-bottom: 1px solid #e5e7eb;">
                            <!-- Search input for scenarios -->
                            <div style="margin-bottom: 8px;">
                                <input type="text" pInputText placeholder="Search scenarios..."
                                       [ngModel]="viewModel.getGroupScenarioSearch(group.name)"
                                       (ngModelChange)="viewModel.setGroupScenarioSearch(group.name, $event)"
                                       class="w-full"
                                       style="font-size: 12px; padding: 6px 8px;" />
                            </div>
                            <!-- Scrollable scenario list -->
                            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #d1d5db; border-radius: 4px; padding: 4px 12px 4px 4px;">
                                <ng-container *ngIf="viewModel.getFilteredGroupScenarios(group.name).length > 0; else noScenariosFound">
                                    <div *ngFor="let scenario of viewModel.getFilteredGroupScenarios(group.name)" style="display: flex; align-items: center; gap: 8px; padding: 6px 4px; border-radius: 3px;" [style.background-color]="scenario.selected ? '#eff6ff' : 'transparent'">
                                        <p-checkbox [(ngModel)]="scenario.selected" [binary]="true"
                                            [disabled]="!scenario.stepCount || scenario.stepCount === 0 || viewModel.isScenarioPackageExpired(scenario)"
                                            (onChange)="viewModel.onScenarioSelectionChange()">
                                        </p-checkbox>
                                        <span style="font-size: 12px; color: #374151;">{{ scenario.scenarioName }}</span>
                                        <span *ngIf="scenario.scenarioId" style="font-size: 11px; color: #6b7280;">({{ scenario.scenarioId }})</span>
                                        <span style="font-size: 11px; color: #9ca3af; margin-left: auto;">{{ scenario.stepCount || 0 }} steps</span>
                                    </div>
                                </ng-container>
                                <ng-template #noScenariosFound>
                                    <div style="padding: 12px 8px; text-align: center; color: #9ca3af; font-size: 12px;">
                                        No scenarios found
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Unselected Groups -->
                <div *ngIf="viewModel.disabledGroups().length > 0" class="section-label-bar">
                    Unselected Groups ({{ viewModel.disabledGroups().length }})
                </div>
                <div class="group-list">
                    <div *ngFor="let group of viewModel.disabledGroups()" class="group-item" [class.disabled]="viewModel.isGroupDisabled(group.name)">
                        <div class="gi-icon" style="background: #f3f4f6; color: #9ca3af;">
                            <i class="pi" [ngClass]="viewModel.getGroupIcon(group.name)"></i>
                        </div>
                        <div class="gi-body">
                            <div class="gi-name">{{ group.name }}</div>
                            <div class="gi-meta">
                                {{ group.scenarioCount }} scenarios
                            </div>
                        </div>
                        <div class="gi-right">
                            <span class="gi-scenarios">{{ group.scenarioCount }} scenarios</span>
                            <button class="toggle-btn off" (click)="viewModel.toggleGroup(group.name)" [disabled]="viewModel.isGroupDisabled(group.name)"></button>
                        </div>
                    </div>
                </div>

                <!-- Execution Config Bar -->
                <div class="exec-config-bar" *ngIf="viewModel.enabledGroups().length > 0">
                    <div class="ecb-item">
                        <span class="ecb-label">Groups:</span>
                        <span class="ecb-value">{{ viewModel.enabledGroups().length }} groups</span>
                        <span class="ecb-sub">({{ viewModel.totalEnabledScenarios() }} scenarios)</span>
                    </div>
                    <div class="ecb-actions" style="display: flex; align-items: center; gap: 12px;">
                        <ng-container *ngIf="viewModel.showTenantSelector()">
                            <span class="ecb-label">Tenant <span style="color: #ef4444;">*</span>:</span>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div *ngFor="let tenant of viewModel.tenantOptions()" style="display: flex; align-items: center; gap: 4px;">
                                    <p-radioButton [name]="'groupTenant'" [value]="tenant.id"
                                        [ngModel]="viewModel.selectedTenantId()"
                                        (onClick)="viewModel.selectTenant(tenant.id)">
                                    </p-radioButton>
                                    <label style="color: white; font-size: 12px; cursor: pointer;" (click)="viewModel.selectTenant(tenant.id)">{{ tenant.displayLabel }}</label>
                                </div>
                            </div>
                        </ng-container>
                        <button class="btn-execute-group"
                            [disabled]="!viewModel.canExecuteGroups()"
                            (click)="viewModel.executeGroups()">
                            <i class="pi pi-play-circle"></i> Execute Groups ({{ viewModel.enabledGroups().length }})
                        </button>
                    </div>
                </div>
            </ng-container>
        </p-fluid>

    </div>
</div>

<!-- This is not in use currently -->
<!-- Multi-Scenario Execution Dialog -->
<p-dialog [visible]="viewModel.multiExecutionDialog()" 
          (visibleChange)="viewModel.multiExecutionDialog.set($event)"
          [style]="{ width: '900px', maxHeight: '80vh' }"
          [modal]="true"
          [closable]="!viewModel.isMultiExecuting()"
          [closeOnEscape]="!viewModel.isMultiExecuting()"
          header="Execute Multiple Scenarios">
    
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <span class="font-bold text-xl">Execute Multiple Scenarios</span>
            <p-tag [value]="viewModel.multiExecutionQueue().length + ' Selected'" severity="info"></p-tag>
        </div>
    </ng-template>

    <div class="multi-execution-content" *ngIf="viewModel.multiExecutionQueue().length > 0">
        <!-- Overall Progress -->
        <div class="mb-4 p-3 bg-blue-50 border-round">
            <div class="flex align-items-center gap-2 mb-2">
                <i *ngIf="viewModel.isMultiExecuting()" class="pi pi-spin pi-spinner text-blue-500"></i>
                <i *ngIf="!viewModel.isMultiExecuting() && viewModel.currentMultiExecutionIndex() >= 0" class="pi pi-check-circle text-green-500"></i>
                <span class="font-semibold">
                    <ng-container *ngIf="viewModel.isMultiExecuting()">
                        Executing scenario {{ viewModel.currentMultiExecutionIndex() + 1 }} of {{ viewModel.multiExecutionQueue().length }}
                    </ng-container>
                    <ng-container *ngIf="!viewModel.isMultiExecuting() && viewModel.currentMultiExecutionIndex() >= 0">
                        Completed {{ viewModel.multiExecutionQueue().length }} scenario(s)
                    </ng-container>
                </span>
            </div>
            <!-- Show current scenario step progress if available -->
            <ng-container *ngIf="viewModel.getCurrentScenarioProgress() as progress">
                <div class="text-sm text-gray-600 mb-2">
                    Step {{ progress.current }} of {{ progress.total }}
                    <span *ngIf="progress.passed !== undefined"> - Passed: {{ progress.passed }}, Failed: {{ progress.failed || 0 }}</span>
                </div>
                <p-progressBar [value]="progress.total > 0 ? Math.round((progress.current / progress.total) * 100) : 0"></p-progressBar>
            </ng-container>
            <!-- Fallback to scenario-level progress -->
            <ng-container *ngIf="!viewModel.getCurrentScenarioProgress()">
                <p-progressBar *ngIf="viewModel.isMultiExecuting()" 
                               [value]="0"></p-progressBar>
                <p-progressBar *ngIf="!viewModel.isMultiExecuting() && viewModel.currentMultiExecutionIndex() >= 0" 
                               [value]="100"></p-progressBar>
            </ng-container>
        </div>

        <!-- Execution Settings -->
        <div class="mb-4 p-3 bg-gray-50 border-round">
            <label class="block font-medium mb-2">Inter-Scenario Delay</label>
            <div class="flex align-items-center gap-2">
                <p-inputNumber [ngModel]="viewModel.interScenarioDelay()" 
                    (ngModelChange)="viewModel.interScenarioDelay.set($event)"
                    [min]="0" 
                    [max]="10000" 
                    [step]="1000"
                    [disabled]="viewModel.isMultiExecuting()">
                </p-inputNumber>
                <span class="text-sm text-gray-600">milliseconds ({{ viewModel.interScenarioDelay() / 1000 }} seconds)</span>
            </div>
        </div>

        <!-- Scenarios Grouped by Functional Area -->
        <div *ngFor="let group of viewModel.groupedScenarios()" class="mb-4">
            <p-fieldset [legend]="group.functionalArea" [toggleable]="true">
                <p-table [value]="group.scenarios" 
                         [tableStyle]="{ 'min-width': '100%' }"
                         styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>
                            <th style="width: 4rem">Seq</th>
                            <th style="width: 12rem">Scenario ID</th>
                            <th style="width: 20rem">Scenario Name</th>
                            <th>Description</th>
                            <th style="width: 8rem">Status</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-scenario>
                        <tr [class.bg-blue-50]="viewModel.draggedScenarioIndex === scenario._queueIndex"
                            [class.border-top-2]="viewModel.dropTargetIndex === scenario._queueIndex"
                            [class.border-blue-500]="viewModel.dropTargetIndex === scenario._queueIndex"
                            draggable="true"
                            (dragstart)="viewModel.onDragStart($event, scenario._queueIndex)"
                            (dragover)="viewModel.onDragOver($event, scenario._queueIndex)"
                            (drop)="viewModel.onDrop($event, scenario._queueIndex)"
                            (dragend)="viewModel.onDragEnd()">
                            <td class="text-center">
                                <i class="pi pi-bars cursor-move text-gray-400" 
                                   *ngIf="!viewModel.isMultiExecuting()"
                                   pTooltip="Drag to reorder"></i>
                            </td>
                            <td class="text-center font-semibold">{{ scenario._queueIndex + 1 }}</td>
                            <td>{{ scenario.scenarioId }}</td>
                            <td class="font-medium">{{ scenario.scenarioName }}</td>
                            <td class="text-sm">{{ scenario.scenarioDescription || '-' }}</td>
                            <td class="text-center">
                                <!-- Running status -->
                                <p-tag *ngIf="viewModel.currentMultiExecutionIndex() === scenario._queueIndex && viewModel.isMultiExecuting()" 
                                       value="Running" 
                                       severity="warning"
                                       [rounded]="true">
                                    <i class="pi pi-spin pi-spinner mr-1"></i>
                                </p-tag>
                                <!-- Completed status with results (show for completed and current scenario when execution is done) -->
                                <ng-container *ngIf="(viewModel.currentMultiExecutionIndex() > scenario._queueIndex) || (viewModel.currentMultiExecutionIndex() >= scenario._queueIndex && !viewModel.isMultiExecuting())">
                                    <ng-container *ngIf="viewModel.getScenarioResult(scenario.id) as result">
                                        <div class="flex flex-column gap-1 align-items-center">
                                            <p-tag *ngIf="result.failed && result.failed > 0" 
                                                   [value]="'Failed ' + result.passed + '/' + (result.passed + result.failed)" 
                                                   severity="danger"
                                                   [rounded]="true"></p-tag>
                                            <p-tag *ngIf="!result.failed || result.failed === 0" 
                                                   [value]="'Passed ' + result.passed + '/' + result.total" 
                                                   severity="success"
                                                   [rounded]="true"></p-tag>
                                            <!-- <span class="text-xs text-gray-500">{{ result.stepsExecuted }} Steps</span> -->
                                        </div>
                                    </ng-container>
                                    <p-tag *ngIf="!viewModel.getScenarioResult(scenario.id)" 
                                           value="Completed" 
                                           severity="success"
                                           [rounded]="true"></p-tag>
                                </ng-container>
                                <!-- Queued status -->
                                <p-tag *ngIf="viewModel.currentMultiExecutionIndex() < scenario._queueIndex && viewModel.isMultiExecuting()" 
                                       value="Queued" 
                                       severity="secondary"
                                       [rounded]="true"></p-tag>
                                <!-- Not Started status -->
                                <p-tag *ngIf="viewModel.currentMultiExecutionIndex() < scenario._queueIndex && !viewModel.isMultiExecuting()" 
                                       value="Not Started" 
                                       severity="secondary"
                                       [rounded]="true"></p-tag>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-fieldset>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end align-items-center gap-2">
            <p-button *ngIf="viewModel.isMultiExecuting()" 
                      label="Stop After Current" 
                      icon="pi pi-stop-circle" 
                      severity="danger" 
                      (click)="viewModel.stopMultiExecution()" />
            <p-button label="Cancel" 
                      icon="pi pi-times" 
                      severity="warn"
                      [disabled]="viewModel.isMultiExecuting()"
                      (click)="viewModel.closeMultiExecutionDialog()" />
            <p-button label="Execute All" 
                      icon="pi pi-play" 
                      severity="success"
                      [disabled]="viewModel.isMultiExecuting()"
                      (click)="viewModel.executeMultipleScenarios()" />
        </div>
    </ng-template>
</p-dialog>

<!-- Execution Results Dialog -->
<p-dialog [visible]="viewModel.resultDialog()" 
          (visibleChange)="viewModel.resultDialog.set($event)"
          [style]="{ width: '70vw', maxHeight: '85vh' }"
          [modal]="true"
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          header="Test Execution Results">
    
    <!-- Simple centered loader without animation -->
    <div *ngIf="viewModel.resultDialog() && !viewModel.resultDialogData()" class="flex align-items-center justify-content-center text-center" style="min-height: 220px;">
        <div>
            <div class="text-900 font-medium mb-2">Loading results...</div>
            <div class="text-600 text-sm">Please wait</div>
        </div>
    </div>

    <div *ngIf="viewModel.resultDialogData() as data" class="execution-results-content">
        <!-- Summary Cards -->
        <div class="results-grid mb-4">
            <div class="metrics">
                <div class="metric-card">
                    <div class="metric-value">{{ data.summary.totalScenarios }}</div>
                    <div class="metric-label">Total Scenarios</div>
                </div>
                <div class="metric-card">
                    <div class="metric-value text-green-600">{{ data.summary.passed }}</div>
                    <div class="metric-label">Passed</div>
                </div>
                <div class="metric-card">
                    <div class="metric-value text-red-600">{{ data.summary.failed }}</div>
                    <div class="metric-label">Failed</div>
                </div>
                <div class="metric-card">
                    <div class="metric-value text-primary">{{ data.summary.successRate }}%</div>
                    <div class="metric-label">Success Rate</div>
                </div>
            </div>
        </div>

        <!-- Scenario Table -->
        <div class="results-table">
            <p-table [value]="data.results" [tableStyle]="{ 'min-width': '100%' }" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 16rem">Scenario</th>
                        <th style="width: 10rem">Result</th>
                        <th>Description</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td class="font-semibold">{{ row.scenarioId || row.scenarioName }}</td>
                        <td>
                            <p-tag [severity]="row.passed ? 'success' : 'danger'" [value]="row.passed ? ('Passed ' + row.passedCount + '/' + row.totalCount) : ('Failed ' + row.failedCount + '/' + row.totalCount)" />
                        </td>
                        <td>
                            <!-- <span class="font-semibold" *ngIf="!row.passed">Failed: {{ row.failedCount }}/{{ row.totalCount }}</span>
                            <span class="font-semibold" *ngIf="row.passed">Passed: {{ row.passedCount }}/{{ row.totalCount }}</span> -->
                            <span class="ml-2" *ngIf="row.scenarioName">{{ row.scenarioName }}</span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Close" icon="pi pi-times" (click)="viewModel.closeResultDialog()" severity="secondary"></p-button>
    </ng-template>
</p-dialog>

